var render = function(_h, _vm) {
  var _c = _vm._c
  return _c(
    "div",
    { staticClass: "progress-line mb-2" },
    [
      _c("v-progress-linear", {
        model: {
          value: _vm.props.value,
          callback: function($$v) {
            _vm.$set(_vm.props, "value", $$v)
          },
          expression: "props.value"
        }
      }),
      _c(
        "v-flex",
        {
          staticClass: "d-flex p-0",
          attrs: { row: "", "justify-space-between": "" }
        },
        [
          _c(
            "span",
            { staticClass: "active text-md-left", attrs: { width: "80px" } },
            [_vm._v("Registrar el "), _c("br"), _vm._v("negocio")]
          ),
          _c("span", { staticClass: "text-md-center text-xs-center" }, [
            _vm._v("Configura la"),
            _c("br"),
            _vm._v("solucion")
          ]),
          _c("span", { staticClass: "text-md-center text-xs-center" }, [
            _vm.props.HasNotification
              ? _c("span", [_vm._v("Envió de "), _c("br"), _vm._v(" términos")])
              : _vm.props.onHold
              ? _c("span", [_vm._v("En espera")])
              : _c("span", [
                  _vm._v("Resumen de"),
                  _c("br"),
                  _vm._v("afiliación")
                ])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-34ff360e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34ff360e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{"stripWithFunctional":true}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/progress-line.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-34ff360e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{"stripWithFunctional":true}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/progress-line.vue
// module chunks = 0 1 5